import { useCountUp, formatCompact } from "@/hooks/useCountUp";
import { FadeIn } from "./Reveal";

const Counter = ({ target, label, testId }) => {
  const [ref, value] = useCountUp(target);
  return (
    <div ref={ref} className="border border-[#1f1f1f] bg-[#101010] p-8 md:p-12 relative group overflow-hidden" data-testid={testId}>
      <div className="absolute inset-0 bg-gradient-to-br from-[#8B0000]/0 to-[#8B0000]/0 group-hover:from-[#8B0000]/10 group-hover:to-transparent transition-all duration-700" />
      <p className="font-blackletter text-5xl md:text-7xl lg:text-8xl text-[#EDEDEA] tabular-nums leading-none">
        {formatCompact(value)}
      </p>
      <p className="mt-4 text-xs md:text-sm tracking-[0.3em] text-[#8B0000] uppercase font-semibold">{label}</p>
    </div>
  );
};

export const StatsWall = ({ stats, texts }) => (
  <section data-testid="stats-section" className="relative z-10 py-24 md:py-40 px-6 md:px-12 lg:px-24 bg-[#0A0A0A]">
    <FadeIn>
      <p className="text-[#525252] tracking-[0.5em] text-xs uppercase mb-12">— Rakamlar Yalan Söylemez</p>
    </FadeIn>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <Counter target={stats.tiktok_followers || 8200000} label={stats.tiktok_label || "TikTok Takipçi"} testId="stat-tiktok" />
      <Counter target={stats.tiktok_likes || 431500000} label={stats.likes_label || "TikTok Beğeni"} testId="stat-likes" />
      <Counter target={stats.instagram_followers || 1000000} label={stats.instagram_label || "Instagram Takipçi"} testId="stat-instagram" />
      <Counter target={stats.youtube_subs || 392000} label={stats.youtube_label || "YouTube Abone"} testId="stat-youtube" />
    </div>
    <FadeIn delay={0.2}>
      <p data-testid="stats-subline" className="mt-10 text-sm md:text-base text-[#A3A3A3] max-w-3xl">
        {texts.stats_subline}
      </p>
    </FadeIn>
  </section>
);
